import { render, staticRenderFns } from "./whats-new.vue?vue&type=template&id=2c50d187&scoped=true&"
import script from "./whats-new.vue?vue&type=script&lang=js&"
export * from "./whats-new.vue?vue&type=script&lang=js&"
import style0 from "./whats-new.vue?vue&type=style&index=0&id=2c50d187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c50d187",
  null
  
)

export default component.exports